import {Injectable, Inject} from 'ng-metadata/core';
import {getVid, getBackendSystem} from '../appConfig/appConfigForward';
var angular: angular.IAngularStatic = require('angular');

@Injectable()
export class TagsService {
    public popularTags: Array<TagItem>;
    public recentTags: Array<TagItem>;
    public myTags: Array<TagItem>;
    public recordNonUserTags: Array<TagItem>;
    public allRecordNonUserTags: Array<TagItem>;//for show more option
    public recordUserTags: Array<TagItem>;
    public tagsSearchResult: Array<TagItem>;
    private GET_API_URL: string;
    public isInSearch: boolean;    
    public showAllNonUserTags: boolean;//to show all the tags when there are more then non user 10 tags
    public searchInProgress: boolean;//to show progress animation while searching for a tag
    public tagsBulkSize: number = 20;
    
    constructor( @Inject('$http') private $http: angular.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs) {

    }

    /*
    gets three lists from the api of: popular Tags, recent Tag, recent User Tags (if logged in)
    */
    public getTagsFromApi() {
        let url = this.restBaseURLs.tagsBaseURL;
        if(getBackendSystem() === 'suprima'){
           url += '?vid=' +  getVid();
        }
        this.$http.get(url).then(
            (response) => {
                this.popularTags = response.data.popularTags;
                this.recentTags = response.data.recentTag;
                this.myTags = response.data.recentUserTags;
            });
    }
    
        
    /*
    performs a tags search containing the mainSearchField 
    gets from the api: all the tags that that contains the mainSearchField
    */
    public doTagsSearch(mainSearchField){
        this.searchInProgress = true;
        this.GET_API_URL = this.restBaseURLs.tagsSearchBaseURL+mainSearchField;
        this.$http.get(this.GET_API_URL).then(
            (response) => {
                this.searchInProgress = false;
                this.tagsSearchResult = response.data.tagsSearchResult;
            });
    }
    
    /*
    gets the tags of the record from the DB in order to display it in the tags section in the fullview
    */
    public getRecordTagsFromApi(recordId){
        let url = this.getEncodedApiUrlForRecordID(recordId);
        this.$http.get(this.GET_API_URL).then(
            (response) => {
                this.allRecordNonUserTags =  response.data.nonUserTags;
                this.recordUserTags =  response.data.userTags;
                if(this.allRecordNonUserTags.length < this.tagsBulkSize){
                    this.showAllNonUserTags = true;
                    this.recordNonUserTags = this.allRecordNonUserTags;
                }
                else{
                    this.showAllNonUserTags = false;
                    this.recordNonUserTags = this.allRecordNonUserTags.slice(0,this.tagsBulkSize);
                }
            });
    }
    
    /*
    adds the tag to the DB or returns an error message otherwise 
    */
    public addTag(item,tagName){
        let url = this.getEncodedApiUrlForRecordID(item.pnx.control.recordid);
        let context = this.getContext(item);
        
        let payload = {"add":{  "tagName":tagName,
                                "context":context,
                                "pnx": item.pnx}};

        return this.$http.post(url, payload);
    }
    
    /*
    removes the tag from the DB or returns an error message otherwise 
    */
    public removeTag(item,tagName){
        let url = this.getEncodedApiUrlForRecordID(item.pnx.control.recordid);
        let payload = {"delete":{"tagName":tagName}};
        return this.$http.post(url, payload);
    }
    
    private  getEncodedApiUrlForRecordID(recordId: any): string {
        if(getBackendSystem() !== 'suprima'){
            recordId = Array.isArray(recordId) ? recordId[0].replaceAll('/', '|slash|') : recordId.replaceAll('/', '|slash|');
        }
        this.GET_API_URL = this.restBaseURLs.tagsBaseURL + '/' + encodeURI(recordId);
        return this.GET_API_URL
    }

    /*
    returns the context of item 
    */
    public getContext(item) {
       let recordId = item.pnx.control.recordid[0];
       let context = item.context
       if (context === undefined){
           if (recordId.startsWith("TN_")) {
               context = "PC";
           }
           else if (recordId.startsWith("RS_")) {
               context = "SP";
           }
           else {
               context = "L";
           }
       }
       return context; 
    }
    
    /*
    shows all the tags when there are more then non user 10 tags
    */
    public showAllRecordNonUserTags(){
        this.showAllNonUserTags = true;
        this.recordNonUserTags = this.allRecordNonUserTags;
    }
    
}    

/*
Used for the tag object
*/
export interface TagItemInterface {
    count: number;
    tagName: string;
}

export class TagItem implements TagItemInterface {
    public count: number;
    public tagName: string;

    constructor(tagItem: TagItem) {
        this.count = tagItem.count;
        this.tagName = tagItem.tagName;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tags.service.ts